import { fg } from '@atlaskit/platform-feature-flags/fg';

import { getAssetsPartials } from './assets';
import { getAtlasPartials } from './atlas';
import { getCompassPartials } from './compass';
import { getConfluencePartials } from './confluence';
import { getJiraPartials } from './jira';
import { getLoomEntityPartials } from './loom-entity';
import { getLoomVideoPartials } from './loom-video';
import { getMercuryPartials } from './mercury';
import { getTalentPartials } from './talent';
import { getFederatedPartials } from './third-party-federated-entity';
import { getGraphPartials } from './third-party-graph-entity';
import { getTrelloPartials } from './trello';

export const getSupportedPartials = (serveUserShardUI: boolean = false) => {
	return `
		${getConfluencePartials(serveUserShardUI)}
		${getJiraPartials()}
		${getTrelloPartials()}
		${getAtlasPartials()}
		${getCompassPartials()}
		${getMercuryPartials()}
		${fg('loom-rovo-search') ? getLoomEntityPartials() : ''}
		${fg('loom-rovo-search') ? getLoomVideoPartials() : ''}
		${getGraphPartials()}
		${getFederatedPartials()}
		${fg('assets_rovo_search_all') ? getAssetsPartials() : ''}
		${fg('talent_global_search') ? getTalentPartials() : ''}
	`;
};
